/**
 * It contains model of Merchant Profile object.
 */

// import { parse, serialize } from "../general.js";

/**
 * Model for Merchant Profile.
 */
const MODEL_MERCHANT_PROFILE = {
  // id:"",           // {string}   Id.(number in the server).
  // merchantId:, ""  // {string}   Merchant Id.(number in the server).
  name: "",           // {string}   Name.
  description: "",    // {string}   Description.
  logoUrl: "",        // {string}   Url of Logo image.
  imagesUrl: [],      // {string[]} Urls of Images.
  phone: "",          // {string}   Phone number.
  email: "",          // {string}   Email.
  website: "",        // {string}   Url of the website.
  businessLines: [],  // {string[]} Categories for the business.
  address: {},        // {Object}   Address: Refer to MODEL_ADDRESS.
  stores: [],         // {Object[]} Merchant Stores: Refer to MODEL_MERCHANT_STORE.
  ayrshareKey:"",     // {string} Ayrshare Profile key
  stripeCustomerId:"", // {string} Stripe Customer Id
};

export const businessTypes = [
  {
    id: 0,
    title: "Digital marketing",
    img: "/assets/img/digital_marketing.svg",
  },
  {
    id: 1,
    title: "Food/Beverage",
    img: "/assets/img/FoodBeverage.svg",
  },
  {
    id: 2,
    title: "Clothing",
    img: "/assets/img/hanger.svg",
  },
  {
    id: 3,
    title: "Automotive",
    img: "/assets/img/car.svg",
  },
  {
    id: 4,
    title: "Beauty",
    img: "/assets/img/lotus.svg",
  },
  {
    id: 5,
    title: "Entertainment",
    img: "/assets/img/ticket.svg",
  },
  {
    id: 6,
    title: "Pet Store",
    img: "/assets/img/track.svg",
  },
  {
    id: 7,
    title: "Sports and Fitness",
    img: "/assets/img/sport.svg",
  },
  {
    id: 8,
    title: "Toy Store",
    img: "/assets/img/toys.svg",
  },
  {
    id: 9,
    title: "Studios",
    img: "/assets/img/artist.svg",
  },
  {
    id: 10,
    title: "Retails",
    img: "/assets/img/shop-bag.svg",
  },
  {
    id: 11,
    title: "Pet Health Technology Service",
    img: "/assets/img/pet_health.svg"
  },
  {
    id: 12,
    title: "German Bakery",
    img: "/assets/img/german_bakery.svg"
  }
];

export const businessCategoriesWithTypes = {
  "Food/Beverage" : [
    {
      id: 0,
      title: "Restaurant",
      img: "/assets/img/business_category_restaurant.svg"
    },
    {
      id: 1,
      title: "Hamburger",
      img: "/assets/img/business_category_hamburger.svg"
    },
    {
      id: 2,
      title: "Pizza",
      img: "/assets/img/business_category_pizza.svg"
    },
    {
      id: 3,
      title: "Grill",
      img: "/assets/img/business_category_grill.svg"
    },
    {
      id: 4,
      title: "Seafood",
      img: "/assets/img/business_category_seafood.svg"
    },
    {
      id: 5,
      title: "Coffee Shop",
      img: "/assets/img/business_category_coffee_house.svg"
    },
    {
      id: 6,
      title: "Bar",
      img: "/assets/img/business_category_bar.svg"
    },
    {
      id: 7,
      title: "Bakery",
      img: "/assets/img/business_category_bakery.png"
    },
    {
      id: 8,
      title: "Ice Cream/Forzen Yogurt",
      img: "/assets/img/business_category_ice_cream.png"
    },
    {
      id: 9,
      title: "Shawarma",
      img: "/assets/img/shawarma_logo.svg"
    },
    {
      id: 10,
      title: "German Bakery 1",
      img: "/assets/german_bakery.svg"
    },
  ],
  "Clothing": [
    {
      id: 0,
      title: "Men's Clothing",
      img: "/assets/img/hanger.svg"
    },
    {
      id: 1,
      title: "Women's Clothing",
      img: "/assets/img/hanger.svg"
    },
    {
      id: 2,
      title: "Kid's Clothing",
      img: "/assets/img/hanger.svg"
    },
    {
      id: 3,
      title: "Casual Wear",
      img: "/assets/img/hanger.svg"
    },
    {
      id: 4,
      title: "Formal Wear",
      img: "/assets/img/hanger.svg"
    },
    {
      id: 5,
      title: "Business Attire",
      img: "/assets/img/hanger.svg"
    }

  ],
  "Automotive": [
    {
      id: 0,
      title: "Car Repair",
      img: "/assets/img/car_repair_logo.svg"
    },
    {
      id: 1,
      title: "Car Parts ",
      img: "/assets/img/car_parts_logo.svg"
    },
    {
      id: 2,
      title: "Car Dealership",
      img: "/assets/img/car_dealership_logo.svg"
    }
  ],
  "Beauty": [
    {
      id: 0,
      title: "Spa",
      img: "/assets/img/stones.svg"
    },
    {
      id: 1,
      title: "Nail Salon",
      img: "/assets/img/nail-polish.svg"
    },
    {
      id: 2,
      title: "Hair Salon - Men",
      img: "/assets/img/hair-dryer.svg"
    },
    {
      id: 3,
      title: "Hair Salon - Women",
      img: "/assets/img/hair-dryer.svg"
    },
    {
      id: 4,
      title: "Hair Salon - Unisex",
      img: "/assets/img/hair-dryer.svg"
    },
    {
      id: 5,
      title: "Skincare",
      img: "/assets/img/dimples.svg"
    },
    {
      id: 6,
      title: "Makeup accessories",
      img: "/assets/img/lotus.svg"
    },
  ],
  "Entertainment": [
    {
      id: 0,
      title: "Sport Complex",
      img: "/assets/img/dumbbell.svg"
    },
    {
      id: 1,
      title: "Theater",
      img: "/assets/img/theater.svg"
    },
    {
      id: 2,
      title: "Golf",
      img: "/assets/img/golf-stick.svg"
    },
    {
      id: 3,
      title: "Bowling",
      img: "/assets/img/bowling.svg"
    },
  ],
  "Pet Store": [
    {
      id: 0,
      title: "Cat Food",
      img: "/assets/img/track.svg"
    },
    {
      id: 1,
      title: "Dog Food",
      img: "/assets/img/track.svg"
    },
    {
      id: 2,
      title: "Bird feed",
      img: "/assets/img/track.svg"
    },
    {
      id: 3,
      title: "Pet accessories",
      img: "/assets/img/track.svg"
    },
    {
      id: 4,
      title: "Acquatic supplies",
      img: "/assets/img/track.svg"
    },
    {
      id: 5,
      title: "Grooming services",
      img: "/assets/img/track.svg"
    },
    {
      id: 6,
      title: "Pet Toys",
      img: "/assets/img/track.svg"
    }
  ],
  "Sports and Fitness": [
    {
      id: 0,
      title: "Nutrition and Supplements Store",
      img: "/assets/img/sport.svg",
    },
    {
      id: 1,
      title: "Gym Membership",
      img: "/assets/img/sport.svg",
    },
  ],
  "Toy Store": [
    {
      id: 0,
      title: "Toy Store",
      img: "/assets/img/toys.svg"
    }
  ],
  "Studios": [
    {
      id: 0,
      title: "Studios",
      img: "/assets/img/artist.svg"
    }
  ],
  "Retails": [
    {
      id: 0,
      title: "Game Shop",
      img: "/assets/img/gamepad.svg"
    },
    {
      id: 1,
      title: "Gift Shop",
      img: "/assets/img/shopping-bag.svg"
    },
    {
      id: 2,
      title: "Vape Shop",
      img: "/assets/img/electronic-cigarette.svg"
    },
    {
      id: 3,
      title: "Cannabis Shop",
      img: "/assets/img/cannabis_logo.svg"
    },
  ],
  "Digital marketing": [
    {
      id: 0,
      title: "Social Media Advertising",
      img: "/assets/img/social_media_logo.svg"
    },
    {
      id: 1,
      title: "Instagram advertising",
      img: "/assets/img/instagram_logo.svg"
    },
    {
      id: 2,
      title: "Twitter/X.com advertising",
      img: "/assets/img/x_logo.svg"
    },
    {
      id: 3,
      title: "Facebook advertising",
      img: "/assets/img/facebook_logo.svg"
    },
    {
      id: 4,
      title: "WhatsApp marketing",
      img: "/assets/img/whatsapp_logo.svg"
    },
  ],
  "Pet Health Technology Service": [
 {
   id: 0,
   title: "Pet Healthcare",
   img: "/assets/img/8814459_pet_love_dog_cat_hug_icon.svg"
 },
 {
   id: 1,
   title: "Veterinary Technology",
   img: "/assets/img/7808444_pet_doctor_vet_veterinary_man_icon.svg"
 },
 {
   id: 2,
   title: "Telemedicine",
   img: "/assets/img/8259399_telemedicine_medical_communication_medicine_icon.svg"
 },
 {
   id: 3,
   title: "Pet Health",
   img: "/assets/img/9159841_veterinary_checkup_medical_treatment_healthcare_icon.svg"
 },
 {
   id: 4,
   title: "Pet Services",
   img: "/assets/img/9159849_veterinary_pet_health_treatment_collar_icon.svg"
 },
 {
   id: 5,
   title: "Digital Health Platform",
   img: "/assets/img/digital_health_platform_logo.svg"
 },
 {
   id: 6,
   title: "Veterinary Telehealth",
   img: "/assets/img/veterinary_telehealth_logo.svg"
 },
 {
   id: 7,
   title: "Pet Wellness",
   img: "/assets/img/pet_wellness_logo.svg"
 },
 {
   id: 8,
   title: "Animal Care Technology",
   img: "/assets/img/animal_care_technology_logo.svg"
 },
 {
   id: 9,
   title: "Remote Veterinary Consultation",
   img: "/assets/img/remote_veterinary_consultation_logo.svg"
 },
 {
   id: 10,
   title: "Pet Health Diagnostics",
   img: "/assets/img/pet_health_diagnostics_logo.svg"
 },
 {
   id: 11,
   title: "Veterinary Software",
   img: "/assets/img/veterinary_software_logo.svg"
 },
 {
   id: 12,
   title: "Animal Telemedicine",
   img: "/assets/img/animal_telemedicine_logo.svg"
 },
 {
   id: 13,
   title: "Pet Health Management",
   img: "/assets/img/pet_health_management_logo.svg"
 },
 {
   id: 14,
   title: "Veterinary Support Services",
   img: "/assets/img/veterinary_support_services_logo.svg"
 },
 {
   id: 15,
   title: "Digital Pet Care",
   img: "/assets/img/digital_pet_care_logo.svg"
 },
 {
   id: 16,
   title: "Animal Health Technology",
   img: "/assets/img/animal_health_technology_logo.svg"
 },
 {
   id: 17,
   title: "Pet Medical Services",
   img: "/assets/img/pet_medical_services_logo.svg"
 },
 {
   id: 18,
   title: "Veterinary Consultation Platform",
   img: "/assets/img/veterinary_consultation_platform_logo.svg"
 },
 {
   id: 19,
   title: "Pet Health Solutions",
   img: "/assets/img/pet_health_solutions_logo.svg"
 }
],
"German Bakery": [
 {
   id: 0,
   title: "Traditional German Bakery",
   img: "/assets/img/8188638_bread_german_bakery_flour_homemade_icon.svg"
 },
 {
   id: 1,
   title: "European Bakery",
   img: "/assets/img/european_bakery_logo.svg"
 },
 {
   id: 2,
   title: "Artisan Bread Making",
   img: "/assets/img/artisan_bread_making_logo.svg"
 },
 {
   id: 3,
   title: "German Pastries",
   img: "/assets/img/german_pastries_logo.svg"
 },
 {
   id: 4,
   title: "Specialty Baking",
   img: "/assets/img/specialty_baking_logo.svg"
 },
 {
   id: 5,
   title: "European Confectionery",
   img: "/assets/img/european_confectionery_logo.svg"
 },
 {
   id: 6,
   title: "Traditional Baking",
   img: "/assets/img/traditional_baking_logo.svg"
 },
 {
   id: 7,
   title: "Craft Bakery",
   img: "/assets/img/craft_bakery_logo.svg"
 },
 {
   id: 8,
   title: "German Desserts",
   img: "/assets/img/german_desserts_logo.svg"
 },
 {
   id: 9,
   title: "Sourdough Bakery",
   img: "/assets/img/5342129_bakery_bread_breakfast_doodle_loaf_icon.svg"
 },
 {
   id: 10,
   title: "Pretzel Making",
   img: "/assets/img/pretzel_making_logo.svg"
 },
 {
   id: 11,
   title: "Strudel Specialties",
   img: "/assets/img/981850_bakery_meat_mince_pastry_roll_icon.svg"
 },
 {
   id: 14,
   title: "Rye Bread Specialists",
   img: "/assets/img/9412381_rye_flour_grain_baking_bread_icon.svg"
 },
 {
   id: 17,
   title: "Authentic German Baked Goods",
   img: "/assets/img/6457720_baguette_bread_french_loaf_icon.svg"
 },
 {
   id: 18,
   title: "Croissants",
   img: "/assets/img/5368617_breakfast_croissant_french_pastry_puff_icon.svg"
 },
 {
   id: 19,
   title: "German Holiday Treats",
   img: "/assets/img/german_holiday_treats_logo.svg"
 },
 {
   id: 20,
   title: "Pumpernickel Bread",
   img: "/assets/img/pumpernickel_bread_logo.svg"
 },
 {
   id: 21,
   title: "German Wedding Cakes",
   img: "/assets/img/german_wedding_cakes_logo.svg"
 },
 {
   id: 22,
   title: "Lebkuchen Specialists",
   img: "/assets/img/lebkuchen_specialists_logo.svg"
 },
 {
   id: 23,
   title: "Bavarian Pastries",
   img: "/assets/img/bavarian_pastries_logo.svg"
 },
 {
   id: 24,
   title: "German Breakfast Pastries",
   img: "/assets/img/german_breakfast_pastries_logo.svg"
 },
 {
   id: 25,
   title: "Traditional Bread Baking",
   img: "/assets/img/traditional_bread_baking_logo.svg"
 },
 {
   id: 26,
   title: "European Sweet Shop",
   img: "/assets/img/european_sweet_shop_logo.svg"
 },
 {
   id: 27,
   title: "German Deli Bakery",
   img: "/assets/img/german_deli_bakery_logo.svg"
 },
 {
   id: 28,
   title: "Authentic European Desserts",
   img: "/assets/img/authentic_european_desserts_logo.svg"
 },
 {
   id: 29,
   title: "German Cultural Foods",
   img: "/assets/img/german_cultural_foods_logo.svg"
 }
]
}

/**
 * Parse a Merchant Profile object.
 * @param {Object} profile Merchant Profile object: Refer to MODEL_MERCHANT_PROFILE.
 * @return {Object} Prased Merchant Profile object.
 */
export function serializeProfile(profile) {
    // TODO:
    // return serialize(profile, MODEL_MERCHANT_PROFILE);
    return profile;
}

/**
 * Serialize a Merchant Profile object.
 * @param {Object} profile Merchant Profile object: Refer to MODEL_MERCHANT_PROFILE.
 * @return {Object} Serialized Merchant Profile object.
 */
export function parseProfile(profile) {
    // TODO:
    // return serialize(profile, MODEL_MERCHANT_PROFILE);
    return profile;
}
